module.exports = __webpack_public_path__ + "static/media/post-dia-del-disenador.9f925218.jpg";